import { render, staticRenderFns } from "./customDropdown.vue?vue&type=template&id=ea1971c8&"
import script from "./customDropdown.vue?vue&type=script&lang=js&"
export * from "./customDropdown.vue?vue&type=script&lang=js&"
import style0 from "./customDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports